<div class="rate-table-scroll">
  <div class="rate-table">
    <div class="rate-table__col rate-table__col--labels">
      <div class="rate-table__cell rate-table__cell--spacer">&nbsp;</div>
      <div class="rate-table__cell rate-table__cell--row-label">Base</div>

      @if (urgentRate()) {
        <div class="rate-table__cell rate-table__cell--row-label">Urgent</div>
      }
    </div>

    <div class="rate-table__col">
      <div class="rate-table__cell rate-table__cell--header">Hourly</div>
      <div class="rate-table__cell">
        <span class="rate-table__value-group">
          {{ baseRate() | currency }}
          @if (isBaseRateScheduled()) {
            <umss-icon
              name="phosphorInfo"
              [size]="'14px'"
              class="rate-table__scheduled-icon"
              [umssTooltip]="
                'Scheduled rate' +
                (baseRateDateRange() ? ': ' + baseRateDateRange() : '')
              "
              tooltipPosition="top"
              tooltipVariant="dark"
              tooltipSize="small"
            />
          }
        </span>
      </div>

      @if (urgentRate()) {
        <div class="rate-table__cell">{{ urgentRate() | currency }}</div>
      }
    </div>

    <div class="rate-table__col">
      <div class="rate-table__cell rate-table__cell--header">+ Usage Fee</div>
      <div class="rate-table__cell">
        <span class="rate-table__value-group">
          {{ differentialRate() | currency }}
          @if (isDifferentialScheduled()) {
            <umss-icon
              name="phosphorInfo"
              [size]="'14px'"
              class="rate-table__scheduled-icon"
              [umssTooltip]="
                'Scheduled usage fee' +
                (differentialDateRange() ? ': ' + differentialDateRange() : '')
              "
              tooltipPosition="top"
              tooltipVariant="dark"
              tooltipSize="small"
            />
          }
        </span>
      </div>

      @if (urgentRate()) {
        <div class="rate-table__cell">{{ differentialRate() | currency }}</div>
      }
    </div>

    <div class="rate-table__col">
      <div class="rate-table__cell rate-table__cell--header">Total</div>
      <div class="rate-table__cell rate-table__cell--total">
        {{ baseTotal | currency }}
      </div>

      @if (urgentRate()) {
        <div class="rate-table__cell rate-table__cell--total">
          {{ urgentTotal | currency }}
        </div>
      }
    </div>
  </div>
</div>
